import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: '#068fb9',
    },
    secondary: {
      main: '#7fdbf7',
    },
    error: {
      main: red[500],
    },
    background: {
      default: '#fff',
    },
  },

  components: {
    MuiPickersDay: {
      styleOverrides: {
        today: {
          backgroundColor: '#e5f7fd',
          color: '#068fb9',
          border: 'none',
        },
        root: {
          '&.Mui-selected': {
            backgroundColor: '#068fb9',
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#068fb9',
          },
          '&.Mui-selected:focus': {
            backgroundColor: '#068fb9',
          },
          '&.Mui-selected:active': {
            backgroundColor: '#068fb9',
          },
        },
      },
    },
  },
});

export default theme;
